import { TypeOf } from '@guiker/shared-framework'

import { stockSchema } from './stock-schema'

export const createStock = stockSchema

export type CreateStock = TypeOf<typeof createStock>
